<template>
  <div>
    <v-row class="ma-0 mb-2">
      <v-spacer/>
      <v-card-title>Cotizaciones Clientes vs Prospectos</v-card-title>
      <v-spacer/>
    </v-row>
    <apexchart
      type="pie"
      :options="options"
      :series="series"
      height="300"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

const props = defineProps<{ data: Record<string, any> }>();

// Dark mode
const isDarkMode = ref(window.matchMedia('(prefers-color-scheme: dark)').matches);
window.matchMedia('(prefers-color-scheme: dark)')
  .addEventListener('change', e => isDarkMode.value = e.matches);

// Series
const series = computed(() => [
  Number(props.data?.Client?.sum_total ?? 0),
  Number(props.data?.Lead?.sum_total ?? 0),
]);

// === Paleta por hostname ===
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

const dominiomediosPalette = ['#88102e', '#be103b']; // Clientes, Prospectos
const bluePalette          = ['#2563eb', '#60a5fa']; // base + claro

const computedColors = computed(() => (
  hostname === 'crm.dominiomedios.com' ? dominiomediosPalette : bluePalette
));

const options = computed(() => ({
  labels: ['Clientes', 'Prospectos'],
  chart: {
    type: 'pie',
    foreColor: isDarkMode.value ? '#fff' : '#333',
  },
  legend: {
    position: 'bottom',
    labels: { colors: isDarkMode.value ? '#fff' : '#333' },
    markers: { strokeWidth: 0 }
  },
  dataLabels: {
    enabled: true,
    style: {
      fontSize: '21px',
      fontWeight: 900,
      colors: [isDarkMode.value ? '#fff' : 'white'],
    },
    formatter: (val: number) => `${val.toFixed(1)}%`
  },
  stroke: { width: 0 },
  colors: computedColors.value,   // ← paleta dinámica
  yaxis: {
    categories: [],
    labels: {
      formatter: (val: any) =>
        Number(val).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }),
      style: {
        fontSize: '21px',
        fontWeight: 900,
        color: isDarkMode.value ? '#fff' : '#333',
      },
    },
    tickPlacement: 'on'
  },
  responsive: [{
    breakpoint: 480,
    options: { legend: { position: 'bottom' } }
  }]
}));
</script>

<script lang="ts">
export default { name: 'ProspectsByStatus' }
</script>
